import { motion } from "framer-motion";

const REVEAL_INITIAL = { opacity: 0, y: 24 };
const REVEAL_INVIEW = { opacity: 1, y: 0 };
const REVEAL_VIEWPORT = { once: true, margin: "-80px" };

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={REVEAL_INITIAL}
    whileInView={REVEAL_INVIEW}
    viewport={REVEAL_VIEWPORT}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children }) => (
  <span className="text-xs tracking-[0.25em] uppercase text-[#D97736] font-semibold">
    {children}
  </span>
);
